
interface EnvVariables {
    API_URL: string,
}

export const ENV_VARIABLES: EnvVariables = {
    API_URL: process.env.REACT_APP_API_URL as string,
};